import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { initCrashReporter } from './utils/crashReporter';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './config/chartConfig'; // Initialize Chart.js globally
import './config/axiosConfig'; // Initialize axios interceptors

// Safe init: avoid crashing on Android WebView if Capacitor or DOM isn't ready
try {
  initCrashReporter();
} catch (e) {
  console.warn('Crash reporter init skipped:', e);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Skip web-vitals on native (Capacitor) - can use APIs that crash in WebView
const isNative = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();
if (!isNative && typeof reportWebVitals === 'function') {
  reportWebVitals();
}
